<template style="background-color:rgba(52, 52, 56, 0.8);overflow-y:hidden;">
  <div class="qr-scan-container">
    <qrcode-stream @decode="onDecode" @init="onInit">
      <div>
        <img src="@/assets/img/Top_left.svg" class="top_left" />
      </div>
      <div>
        <img src="@/assets/img/Top_right.svg" class="top_right" />
      </div>
      <div>
        <img src="@/assets/img/Bottom_right.svg" class="bottom_right" />
      </div>
      <div>
        <img src="@/assets/img/Bottom_left.svg" class="bottom_left" />
      </div>
      <!--Cross iCON--->
      <div class="cross_icon" @click="goToHome()">
        <!-- @click="onLogout()" -->
        <img src="@/assets/img/cross.svg" height="20" width="20" />
      </div>
      <!--Cross iCON--->
      <!-- <div class="manual_center">
        <button class="manual_btn" @click="goToManual()">
          Enter Manually
        </button>
      </div>

      <div class="showtime_center">
        <button class="showtime_btn" @click="goToShow()">
          Showtimes
        </button>
      </div> -->

      <!-- <footer
        class="d-flex justify-content-center align-items-center showtime-icon"
        :style="errorStatus ? 'margin:10px 10px 42px 10px' : ''"
      >
        <div>
          <div @click="goToShow()" style="background-color: transparent">
            <img
              id="popoverTarget"
              src="@/assets/img/reel.svg"
              style="background-color: transparent"
            />
          </div>

          <b-popover target="popoverTarget" placement="top" show>
            Click here for Showtime!
          </b-popover>
        </div>
      </footer> -->
      <!-- <div class="show_times_btn showtime-icon">
        <button class="showtimes_btn" @click="goToShow()">
          Showtimes
        </button>
      </div> -->
    </qrcode-stream>

    <div></div>
    <div
      class="text-center fixed-bottom"
      style="margin-bottom:20px"
      v-if="errorStatus"
    >
      {{ error }}
    </div>
    <div class="text-center btn btn-primary fixed-bottom" v-if="errorStatus">
      Try Again
    </div>
  </div>
</template>

<script>
export default {
  name: "hello",
  data() {
    return {
      error: "",
      errorStatus: false
    };
  },
  beforeMount() {
    const token = window.localStorage.getItem("JWT_TOKEN");
    if (!token) {
      this.$router.push({
        name: "login"
      });
    }
  },
  methods: {
    goToShow() {
      this.$router.push({
        name: "showtime",
        path: "/showtime"
      });
    },

    goToHome() {
      this.$router.push({
        name: "Home",
        path: "/home"
      });
    },

    goToManual() {
      this.$router.push({
        name: "manual",
        path: "/manual"
      });
    },
    onLogout() {
      window.localStorage.removeItem("JWT_TOKEN");
      window.localStorage.removeItem("USERCINEINFO");
      window.localStorage.clear();
      this.$cookie.delete("BRHSID");
      this.$router.push({
        name: "login"
      });
      return window.caches.keys();
    },
    onDecode(decodedString) {
      this.$router.push({
        name: "details",
        query: { qrcode: decodedString }
      });
    },
    async onInit(promise) {
      try {
        this.errorStatus = false;
        await promise;
      } catch (error) {
        this.errorStatus = true;
        if (error.name === "NotAllowedError") {
          this.error = "ERROR: you need to grant camera access permisson";
        } else if (error.name === "NotFoundError") {
          this.error = "ERROR: no camera on this device";
        } else if (error.name === "NotSupportedError") {
          this.error = "ERROR: secure context required (HTTPS, localhost)";
        } else if (error.name === "NotReadableError") {
          this.error = "ERROR: is the camera already in use?";
        } else if (error.name === "OverconstrainedError") {
          this.error = "ERROR: installed cameras are not suitable";
        } else if (error.name === "StreamApiNotSupportedError") {
          this.error = "ERROR: Stream API is not supported in this browser";
        }
      }
    }
  }
};
</script>
<style>
.showtime-icon {
  /*background-color: white;*/
  border: 1px solid aqua;
  padding: 6px;
  position: absolute;
  bottom: 0;
  right: 0;
  margin: 10px;
  border-radius: 50px;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
.showtimes_btn {
  border: none;
  background: none;
  color: aqua;
  font-weight: bold;
  text-transform: uppercase;
}

.showtime_center {
  position: absolute;
  bottom: 15%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
}

.showtime_btn {
  border: 1px solid aqua;
  background: rgba(0, 0, 0, 0.5);
  color: aqua;
  font-weight: bold;
  text-transform: uppercase;
  padding: 10px 20px;
  border-radius: 25px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.showtime_btn:hover {
  background: rgba(0, 255, 255, 0.2);
}
</style>



// WEBPACK FOOTER //
// src/components/qrCode.vue